export default __webpack_public_path__ + "static/media/remark_calendar.2ece5ea9.svg";